import { Api } from '@coder-house/ch-coder-util'
import { ILocale } from '../models/locale.interface'
import { Locale } from '../models/locale.model'

const { CH_ACADEMIC_CDN } = process.env

async function getLocale(lang: string): Promise<Locale> {
  const locale = await Api.get<ILocale>(`${CH_ACADEMIC_CDN}/v1/languages/${lang}/context/platform/translations-1.1.json`, {}, {
    withCredentials: false
  })
  return new Locale(locale)
}

export { getLocale }
